<template>
   <div>
   <div>
      <el-dialog v-dialogDrag title="图片库" :visible.sync="dialogImgregualte" width='63%'>
               <div class="head">
               <div class="left_seach">
                  <el-select class="drop_down_box" v-model="yearData" placeholder="请选择" @change="(el) => selectClick(el, 'year')">
                     <el-option
                        v-for="item in year"
                        :key="item"
                        :label="item"
                        :value="item">
                      </el-option>
                   </el-select>
                   <i class="line"></i>
                   <el-select  class="drop_down_box" v-model="monthData" placeholder="请选择" @change="(el) => selectClick(el, 'month')">
                     <el-option
                        v-for="val in month"
                        :key="val"
                        :label="val"
                        :value="val">
                      </el-option>
                   </el-select>
                  <el-button  size="small"  class="search" icon="el-icon-search" @click="getresult"></el-button>
               </div>
               <div class="upload">
                  <el-button  type="danger"  size="small" style="margin-right: 20px;" @click="delImg">删除</el-button>
                  <!-- <el-button type="primary"  size="small" @click="upload">上传图片</el-button> -->
                  <el-upload
                  :action="uploadfile"
                  :http-request="uploadAction"
                  :show-file-list="false"
                  :before-upload="beforeAvatarUpload"
                  :on-success="handleinformationSuccess"
                    >
                    <el-button size="small" type="primary">上传图片</el-button>
                  </el-upload>
               </div>
            </div>
            <div class="content">
               <div class="leftMenu">
                  <div class="increase" @click="CreateGroup">
                     <i class="el-icon-circle-plus ico"></i>
                    <span>添加分组</span></div>
                  <div class="increases">
                     <el-menu 
                        default-active="1"
                        class="el-menu-vertical-demo">
                        <!-- <el-submenu index="1"> -->
                           <!-- <template slot="title">
                              <div @click="abc">
                              <i class="el-icon-folder-opened" style="color:#edce86"></i>handleClick
                              <span>全部</span>
                              </div>
                           </template> -->
                           <el-menu-item-group>
                              <div v-for="(item,index) in FileGroupList" :key="item.id">
                                 <el-menu-item :index="'1-'+index" class="menuItem" @click="setBtnClick(item,index)" @mouseover.native="setBtn(item,index)" @mouseleave.native="setBtnLeave(item,index)">
                                    <div style="display: flex;align-items: center;">
                                    <i class="el-icon-folder-opened" style="color:#edce86"></i>
                                    <!-- <el-input v-if="item.edit1" class="inpimg" v-model="filename" @input="getinputDATA"></el-input> -->
                                    <span>{{item.name}}</span>
                                    <i class="el-icon-arrow-right"  v-if="!item.helpFlag" style="position: absolute;left: 0px;top: 17px;font-size: 15px;" @click="setBtns(index)"></i>
                                    <i class="el-icon-arrow-down"  v-if="item.helpFlag" style="position: absolute;left: 0px;top: 17px;font-size: 15px;" @click="setBtns(index)"></i>
                                    <!-- <i class="el-icon-more"  v-if="index == current ? setBtn1 : ''" style="transform:rotate(180deg);position: absolute;right: 0px;top: 17px;" @click="childFile(index)"></i> -->
                                    <el-dropdown trigger="click" style="transform:rotate(180deg);position: absolute;right: 0px;top: 0px;" @command="handleCommand">
                                    <span class="el-dropdown-link" >
                                    <i class="el-icon-more"  v-if="index == current ? setBtn1 : ''"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item icon="el-icon-plus" command="创建子分类">创建子分类</el-dropdown-item>
                                    <el-dropdown-item icon="el-icon-edit" command="修改分类">修改分类</el-dropdown-item>
                                    <el-dropdown-item icon="el-icon-delete" command="删除分类">删除分类</el-dropdown-item>
                                    </el-dropdown-menu>
                                 </el-dropdown>
                                    </div>
                                 </el-menu-item>
                                 <div class="set_foot" v-if="item.helpFlag">
                                    <!-- <el-menu 
                                    default-active="1"
                                    class="el-menu-vertical-demo">
                                    <el-menu-item-group> -->
                                             <div v-for="(val,index_1) in cheildData" :key="val.id">
                                          <el-menu-item :index="'1-'+index + index_1" class="menuItem" @click.native="secondsetBtnClick(val,index_1,name='二级分类')" @mouseover.native="secondsetBtn(val,index_1)" @mouseleave.native="secondsetBtnLeave(val,index_1)" style="padding-left: 40px;">
                                             <div style="display: flex;align-items: center;">
                                             <i class="el-icon-folder-opened" style="color:#edce86"></i>
                                             <!-- <el-input v-if="item.edit1" class="inpimg" v-model="filename" @input="getinputDATA"></el-input> -->
                                             <span>{{val.name}}</span>
                                             <i class="el-icon-arrow-right" v-if="!val.helpFlag" style="position: absolute;left: 15px;top: 17px;font-size: 15px;" @click="setBtns_1(index_1)"></i>
                                             <i class="el-icon-arrow-down" v-if="val.helpFlag" style="position: absolute;left: 15px;top: 17px;font-size: 15px;" @click="setBtns_1(index_1)"></i>
                                             <el-dropdown trigger="click" style="transform:rotate(180deg);position: absolute;right: 0px;top: 0px;" @command="handleCommand">
                                             <span class="el-dropdown-link" >
                                             <i class="el-icon-more" v-if="index_1 == current_1 ? setBtn1 : ''"></i>
                                             </span>
                                             <el-dropdown-menu slot="dropdown">
                                             <el-dropdown-item icon="el-icon-plus" command="创建子分类">创建子分类</el-dropdown-item>
                                             <el-dropdown-item icon="el-icon-edit" command="修改分类">修改分类</el-dropdown-item>
                                             <el-dropdown-item icon="el-icon-delete" command="删除分类">删除分类</el-dropdown-item>
                                             </el-dropdown-menu>
                                          </el-dropdown>
                                             </div>
                                          </el-menu-item>
                                          <div class="set_foot" v-if="val.helpFlag">
                                    <!-- <el-menu 
                                    default-active="1"
                                    class="el-menu-vertical-demo">
                                    <el-menu-item-group> -->
                                             <div v-for="(val2,index_3) in cheildData3" :key="val2.id">
                                          <el-menu-item :index="'1-'+index + index_1+index_3" class="menuItem" @click.native="thirdsetBtnClick(val2,index_3,name='三级分类')" @mouseover.native="thirdsetBtn(val2,index_3)" @mouseleave.native="thirdsetBtnLeave(val2,index_3)"  style="padding-left: 50px;">  
                                             <div style="display: flex;align-items: center;">
                                             <i class="el-icon-folder-opened" style="color:#edce86"></i>
                                             <span>{{val2.name}}</span>
                                             <!-- <i class="el-icon-arrow-down" style="position: absolute;left: 0px;top: 17px;font-size: 15px;" @click="setBtns_1(index_3)" ></i> -->
                                             <el-dropdown trigger="click" style="transform:rotate(180deg);position: absolute;right: 0px;top: 0px;" @command="handleCommand">
                                             <span class="el-dropdown-link" >
                                             <i class="el-icon-more"  v-if="index_3 == current_2 ? setBtn1 : ''"></i>
                                             </span>
                                             <el-dropdown-menu slot="dropdown">
                                             <el-dropdown-item icon="el-icon-edit" command="修改分类">修改分类</el-dropdown-item>
                                             <el-dropdown-item icon="el-icon-delete" command="删除分类">删除分类</el-dropdown-item>
                                             </el-dropdown-menu>
                                          </el-dropdown>
                                             </div>
                                          </el-menu-item>
                                          </div>
                                       <!-- </el-menu-item-group>
                              </el-menu> -->
                                
                                 </div>
                                          </div>
                                       <!-- </el-menu-item-group>
                              </el-menu> -->
                                
                                 </div>
                              </div>
                           </el-menu-item-group>
                        <!-- </el-submenu> -->
                     </el-menu>
                  </div>
               </div>
               <div class="masterPic">
                  <div class="boxUploads">
                  <div v-for="(item,index) in srcList" :key="index" class="demo-image__preview">
                     <el-image
                        style="width: 110px; height: 110px;"
                        :src="item.imgUrl"
                        :preview-src-list="raylist"
                     >
                     </el-image>
                     <div class="checksty">
                        <el-checkbox-group v-model="checkedCities"  @change="clicheck(item)">
                           <el-checkbox :label="item.imgUrl" ><br /></el-checkbox>
                        </el-checkbox-group>
                     </div>
                     <div class="imgName">{{ item.name }}</div>
                  </div>
               </div>
               </div>
            </div>
            <div class="footers">
               <el-checkbox  v-model="checkedImg" @change="isCheck">全选</el-checkbox>
               <el-pagination
                     background
                     @current-change="currentChangeHandle2"
                     :current-page="currentPage2"
                     :page-size="pageSize2"
                     layout="total, prev, pager, next, slot, jumper"
                     :total="currentPage5"
                  >
                  <span slot style="width: 40px;color: dimgrey">
                     <label><input name="Fruit" type="checkbox" value="" v-model="checkedc" @change="all2" />显示全部</label>
                  </span>
            </el-pagination>
            </div>
         
            <span slot="footer" class="dialog-footer">
               <el-button size="medium" type="primary" @click="confirmin" style="margin-right: 30px;">确定</el-button>
               <el-button size="medium"  @click="callOff">取消</el-button>
             </span>
      </el-dialog>
      <el-dialog
      title="修改分类"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
      <!-- <span>这是一段信息</span> -->
      <div>
         <span>分组名称</span>
         <el-input v-model="filename"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
         <el-button @click="dialogVisible = false">取 消</el-button>
         <el-button type="primary" @click="amendFile">确 定</el-button>
      </span>
      </el-dialog>
   </div>
</div>
</template>

<script>
   import {
      backbrary,
      advplateinfo,
      updateadPlateinfo,
      uploadfile,
      scmfile,
      productputaway,
      getFilegroupview,
      CreateGroup,
      uploadPictures,
      showPictures,
      amendPictures,
      amendGroup,
      allPictures
   } from "../../static/API/API.js";
   import * as imageConversion from 'image-conversion'
   export default {
     data() {
       return {
         isIndeterminate: true,
         // 分页总条数
         NumsPage:0,
         // 当前页
         currentPage1:1,
         pageSize:1,
      // 是否显示全部
        checked: false,
        checkedImg:false,
        dialogVisible:false,
        newName:'',
         // 表单
         tableData:[],
         // 年份
         year:['不限年份','2023','2022','2021','2020','2019','2018','2017','2016','2015','2014','2013','2012'],
         // 月份
         month:['不限月份','12','11','10','9','8','7','6','5','4','3','2','1'],
         options: [{
          value: '热销',
          label: '热销'
        },{
          value: '自营',
          label: '自营'
        }],
        value: '热销',
        yearData:'不限年份',
        monthData:'不限月份',
         //   设置按钮
         setBtn1:false,
         // 编辑按钮
         setBtn2:false,
         confirmBtn:'编辑',
         cancelBtn:'删除',
         // 图标切换
         el_icon_edit:'el-icon-edit',
         el_icon_delete:' el-icon-delete',
         //颜色切换
         edit_state:'#409eff',
         delete_state:'#cf1010 ',
         //文件夹名称
         filename:'',
         // 输入框切换
         edit1:true,
         FileGroupList:[],
         current:null,
         current_1:null,
         current_2:null,
         //页码
         pageNumber:1,
         // 页面容量
         PageSize:5,
         // 输入商品
         inputGoods:'',
         // 公司id
         firmId:'',
         listAll:'all',
         // 选择商品弹窗
         dialogGoods:false,
         // 文字标题
          txtTitle:'',
         // 文字链接、跳转链接
          titleLink:'',
         // 文字表单
        labelPosition: 'right',
        //向后端传递的图片接口
        uploadfile: uploadfile,
         // 选中图片的值
         checkedCities:[],
         // 图片库
         srcList: [],
         raylist:[],
         // 选中图片信息
         interlinkageLink: '',
         // 选中图片信息的数组
         boxImg:[],
         //图片序号
         serialNumber:'',
         // 图标标题
         serialTitle:'',
         // 图片库
         dialogImgregualte:false,
         // 图片库是编辑
         dialogImgregualteEdit:false,
         //分页和当前页
         currentPage0:20,
         currentPage2:1,
         pageSize2: 1,
         currentPage5:0,
         // 图片库点击事件的参数
         scmCompanyid2: '',
         userName2:'',
         // 图片库分页全选复选框
         checkedc: false,
         // 接收参数
         plateid: this.$route.query.platea, //板块id
         conteid: this.$route.query.contenid, //内容页id
         info_id: 0, //具体某一张图片的id，用于判断是否是编辑还是添加
         type: this.$route.query.type, //文字
         tophref: window.location.href,
         allName:'全部',
         checkedUrl:[],
         cheildData:[],
         cheildData3:[],
         pitchimg:[]
       };
     },
     mounted(){
      this.preserve()
      this.getfileData()
     },
     methods:{
      handleSelectionChange(val) {
         // let params = new URLSearchParams();
         // params.append('UserId',sessionStorage.getItem('user_id'));//创建人id
         // params.append('AdPageId',this.conteid);//内容页id
         // params.append('AdPlateId',this.plateid);//板块id
         // params.append('ProductId',val[0].LOG_SPOT_SALE_PRODUCT_id_PK);//商品id
         // params.append('Path',val[0].image);//图片路径
         // params.append('SortNum',val[0].rank_num);//序号
         // this.$axios.post(advplateinfo, params).then(res => {
         //    this.dialogGoods = false
         //    this.print()
         // })
      },
      all(){
         if(this.checked){
            this.PageSize = 'all'
            this.queryProduct(1)
         }else{
            this.PageSize = 5
            this.queryProduct(1)
         }
      },
      // 改变当前所在页
      currentChangeHandle(val) {
        this.currentPage1 = val
        this.queryProduct(val)
      },
      // 点击查询按钮
      queryProduct(e){
         let params = new URLSearchParams();
         if(e){
            params.append('page_number',e);//页码
         }else{
            params.append('page_number',this.pageNumber);//页码
         }
         params.append('page_size',this.PageSize);//页面容量
         params.append('keyword',this.inputGoods == '' ? this.value : this.value + ' ' + this.inputGoods);//下拉
         params.append('companyid',this.firmId);//公司id(非必传)
         params.append('ope_type',this.listAll);
         this.$axios.get(productputaway,{
            params
         }).then(res =>{
         console.log(res.data[0],'查询产品');
         this.NumsPage = res.data[0].PageNums //分页总条数
         this.tableData = res.data[0].pagedata
         })
      },
      // 选择商品
      selectGoods(){
        this.dialogGoods = true
         // 查询产品
         this.queryProduct()
      },
      // 修改
      amend(e){
      //   console.log(e,'修改');
      //   let params = new URLSearchParams();
      //    params.append('UserId',sessionStorage.getItem('user_id'));//创建人id
      //    params.append('AdPageId',this.conteid);//内容页id
      //    params.append('AdPlateId',this.plateid);//板块id
      //    params.append('Title',e.Title);//标题
      //    params.append('LinkUrl',e.LinkUrl);//标题链接
      //    params.append('SortNum',e.SortNum);//序号
      //    params.append('Path',e.Path);//图片路径
      //    params.append('info_id',e.Id);//广告详情页id

      //    // params.append('ProductId',this.currentPage0);//商品id
      //    // params.append('PlateInfoKey',this.currentPage0);//内容key
      //    // params.append('ActivityCreateTime',this.currentPage0);//开始时间
      //    // params.append('ActivityEndTime',this.currentPage0);//结束时间
      //    console.log(params);
      //    this.$axios.post(updateadPlateinfo, params).then(res => {
      //       this.$message({
      //          message: '修改成功！',
      //          type: 'success',
      //          duration: 1000,
      //       showClose: true,
      //       });
      //       this.print()
      //    })
      },
      // 删除
      Delete(e){
         let params = new URLSearchParams();
         params.append('info_id',e.Id);//广告详情页id
         this.$axios.get(updateadPlateinfo, {
            params
         }).then(res => {
            this.print()
            console.log(res,'删除');
         })
      },
      // 点击保存
      preserve(){
         // console.log(this.txtTitle);
         // if(Number(this.serialNumber) < -2147483648 || Number(this.serialNumber) > 2147483648){
         //   alert('序号超出范围！')
         // }else{
         //    let params = new URLSearchParams();
         //    params.append('UserId',sessionStorage.getItem('user_id'));//创建人id
         //    params.append('AdPageId',this.conteid);//内容页id
         //    params.append('AdPlateId',this.plateid);//板块id
         //    params.append('Title',this.txtTitle);//标题txtTitle
         //    params.append('LinkUrl',this.titleLink);//标题链接
         //    params.append('Path',this.interlinkageLink);//图片路径
         //    params.append('SortNum',this.serialNumber);//序号
         //    // params.append('ProductId',this.currentPage0);//商品id
         //    // params.append('PlateInfoKey',this.currentPage0);//内容key
         //    // params.append('ActivityCreateTime',this.currentPage0);//开始时间
         //    // params.append('ActivityEndTime',this.currentPage0);//结束时间
         //    this.$axios.post(advplateinfo, params).then(res => {
         //       console.log(res);
         //       this.print()
         //       this.checkedCities = [] //图片库选中按钮取消选中
         //       this.interlinkageLink = '' // 图片路径清空boxImg
         //       this.serialNumber = '' //图片序号清空
         //       this.txtTitle = '' //文字标题清空
         //       this.titleLink = ''//文字链接标题清空
         //    })
         // }
      },
      // 点击保存后调取图片内容接口
      print(){
         // let params = new URLSearchParams();
         // params.append('AdPlateId',this.plateid);//板块id
         // this.$axios.get(advplateinfo,{
         //    params
         // }).then(res =>{
         //    console.log(res.data.message);
         //    this.boxImg = res.data.message
         //    console.log(this.boxImg,'this.boxImg');
         // })
      },
      // 上传图片成功组件
      handleAvatarSuccess(res, file, e) {
         console.log(res, file,e ,'上传图片成功组件');
      // 上传成功之后直接渲染
         e.Path = URL.createObjectURL(file.raw);
         e.Path = res
      },
      // 上传过程 上传后将本地图片传向后台，再返给前端图片链接
      beforeAvatarUpload(file) {
         console.log(file,'上传过程');
         let fd = new FormData();
         fd.append('file', file); //传文件
         this.$axios.post(uploadfile, fd).then(res =>{
            console.log(res.data,'上传图片后的返回');
            let params = new URLSearchParams();
            params.append('ope_type', '添加')
            params.append('link', res.data)
            params.append('companyid', sessionStorage.getItem('companyid'))
            params.append('up_user', sessionStorage.getItem('user_id'))
            this.$axios.post(scmfile, params).then(res=> {
               // this.$message({
               //    type: 'success',
               //    message: res.data
               // });
            })
         })
         const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
        const isLt2M = file.size / 1024 / 1024 < 5

        if (!isJpgOrPng) {
          this.$message.error('上传图片只能是JPG或PNG格式!');
          return false
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 5MB!');
          return false
        }
        return new Promise((resolve) => {
        // 以质量为0.6进行压缩，可自定义
        imageConversion.compress(file,0.8).then(res=>{
			    resolve(res);
		})
    })
      },
      // 选中图片后的处理 点击选中图片后val拿到图片值，
      clicheck(val){
         // this.checkedCities.push(val)
         this.pitchimg.push(val.id)
         this.checkedUrl = JSON.stringify(this.checkedCities)
         // console.log( this.checkedCities);
      //    this.interlinkageLink = val.link
      //    let params = new URLSearchParams();
      //    params.append('UserId',sessionStorage.getItem('user_id'));//创建人id
      //    params.append('AdPageId',this.conteid);//内容页id
      //    params.append('AdPlateId',this.plateid);//板块id
      //    params.append('Title',this.txtTitle);//标题
      //    params.append('LinkUrl',this.titleLink);//标题链接
      //    params.append('Path',val.link);//图片链接路径
      //    params.append('SortNum',1);//序号
      //   //编辑替换
      //   if(this.info_id>0){
      //     params.append('info_id',this.info_id);//序号
      //     this.$axios.post(updateadPlateinfo, params).then(res => {
      //       this.print()
      //       this.checkedCities = [] //图片库选中按钮取消选中
      //       this.interlinkageLink = '' // 图片路径清空
      //       this.serialNumber = '' //图片序号清空
      //       this.txtTitle = '' //文字标题清空
      //       this.titleLink = ''//文字链接标题清空
      //       this.dialogImgregualte = false
      //     })
      //   }else{//添加
      //     this.$axios.post(advplateinfo, params).then(res => {
      //       this.print()
      //       this.checkedCities = [] //图片库选中按钮取消选中
      //       this.interlinkageLink = '' // 图片路径清空
      //       this.serialNumber = '' //图片序号清空
      //       this.txtTitle = '' //文字标题清空
      //       this.titleLink = ''//文字链接标题清空
      //       this.dialogImgregualte = false
      //     })
      //   }



      },
         // 图片库显示全部图片
      all2(){
        if (this.checkedc) {
          this.currentPage0 = 'all'
          this.imglibrary(1, this.scmCompanyid2, this.userName2,this.info_id)
        } else {
          this.currentPage0 = 20
          this.imglibrary(1, this.scmCompanyid2, this.userName2,this.info_id)
        }
      },
      //图片库
      imglibrary(e, companyid2, name2,type){
        this.dialogImgregualte = true
        if(type&&type>0){
          this.info_id = type
        }else {
          this.info_id = 0
        }

      let params = new URLSearchParams();
        if (e) {
          params.append('page_number', e)
        } else {
          params.append('page_number', this.currentPage2)
        }
        params.append('page_size',this.currentPage0);
        params.append('file_type', 'photo');
        params.append('companyid', sessionStorage.getItem('companyid'));
        params.append('year', this.yearData)
         params.append('month', this.monthData)
         params.append('page_size', this.currentPage0)
         params.append('page_number', this.currentPage2)
         this.$axios.get(showPictures, {params}).then(res => {
            let arr = []
          let listlist = []
          this.currentPage5 = Number(res.data['page_total'])
          res.data.page_data.forEach(item =>{
              arr.push(item)
              listlist.push(item.imgUrl)
          })
          this.srcList = arr
          this.raylist = listlist
         })
      },
     
      //图片库分页
      currentChangeHandle2(val){
        this.currentPage2 = val
        this.checkedCities = []
        if(this.allName == '全部'){
            this.imglibrary(this.currentPage2, this.scmCompanyid2, this.userName2,this.info_id)
         }else{
            this.checkedImg = false
            this.setBtnClicks()     
        }

      },
         //   取消按钮
      callOff(){
         this.dialogImgregualte = false
         this.checkedCities = []
         this.interlinkage = ''
      },
   //   图片库分组信息
      getfileData(){
         this.$axios.get(getFilegroupview,{
        }).then(res =>{
         this.FileGroupList = res.data
        })
      },
      // 新增分组
      CreateGroup(){
         this.$axios.post(CreateGroup,{
        }).then(res =>{
         if(res.status == 200){
            this.$message({
              message: '创建成功',
              type: 'success',
              duration: 1000,
              showClose: true,
            });
            this.getfileData()
         }
        })
      },
      // 查询
      getresult(){
         this.setBtnClicks()
      },
      // 确定
      confirmin(){
         this.$emit('deliveryImg',this.checkedUrl)
         this.dialogImgregualte = false
         this.checkedUrl = []
        this.checkedCities = []
      },
      selectClick(val,type) {
         if(type == 'year'){
            this.yearData = val
         }else{
            this.monthData = val
         }
      },
      // 鼠标移入
         setBtn(item,index){
            if(index){
               this.current = index //图标显示隐藏
               this.setBtn1 = true
            }
         },
      // 鼠标移除
      setBtnLeave(item,index){
         this.setBtn1 = false
         this.current = null
      },
      // 选择分组
      setBtnClick(item,index){
         this.newName = ''
         this.currentPage0 = 20,
         this.currentPage2 = 1,
         this.allName = item.name
         if(item.name == '全部'){
            this.imglibrary()
         }else{
         this.flieList = item
         this.groupid = item.FileGroup_id
         this.secondgroupid = item.FileGroup_id
         this.setBtnClicks()
         }
        this.getChildfileData()
      },
      // 选择二级分组
      secondsetBtnClick(val,index_1,name){
         this.newName = name
         this.currentPage0 = 20,
         this.currentPage2 = 1,
         this.allName = val.name
        
         this.flieList = val
         this.groupid = val.FileGroup_id
         this.setBtnClicks()
         this.getChildfileData3()
      },
       // 鼠标移入
      secondsetBtn(val,index_1){
         this.current_1 = index_1 //图标显示隐藏
         this.setBtn1 = true
         },
      // 鼠标移除
      secondsetBtnLeave(item,index){
         this.setBtn1 = false
         this.current_1 = null
      },
      // 选择三级分组
      thirdsetBtnClick(val2,index_1,name){
         this.newName = name
         this.currentPage0 = 20,
         this.currentPage2 = 1,
         this.allName = val2.name
        
         this.flieList = val2
         this.groupid = val2.FileGroup_id
         this.setBtnClicks()
      },
         // 鼠标移入
      thirdsetBtn(val,index_3){  
         this.current_2 = index_3 //图标显示隐藏
         this.setBtn1 = true
         },
      // 鼠标移除
      thirdsetBtnLeave(item,index){
         this.setBtn1 = false
         this.current_2 = null
      },
      setBtnClicks(){
         if(this.allName == '全部'){
         let params = new URLSearchParams();
         params.append('year', this.yearData)
         params.append('month', this.monthData)
         params.append('page_size', this.currentPage0)
         params.append('page_number', this.currentPage2)
         this.$axios.get(showPictures, {params}).then(res => {
            let arr = []
          let listlist = []
          this.currentPage5 = Number(res.data['page_total'])
          res.data.page_data.forEach(item =>{
              arr.push(item)
              listlist.push(item.imgUrl)
          })
          this.srcList = arr
          this.raylist = listlist
         })
         }else{
         let params = new URLSearchParams();
         params.append('groupid', this.groupid)
         params.append('year', this.yearData)
         params.append('month', this.monthData)
         params.append('page_size', this.currentPage0)
         params.append('page_number', this.currentPage2)
         this.$axios.get(showPictures, {params}).then(res => {
            let arr = []
          let listlist = []
          this.currentPage5 = Number(res.data['page_total'])
          res.data.page_data.forEach(item =>{
              arr.push(item)
              listlist.push(item.imgUrl)
          })
          this.srcList = arr
          this.raylist = listlist
         })
         }
      
      },
     setBtns(index){
     var listData = this.FileGroupList 
     var helpFlag = this.FileGroupList[index].helpFlag // 先用一个变量接收一个原来的状态值
     listData.forEach((item) => {  //循环已经把所有的状态值清空了
        item.helpFlag = false
    })
    listData[index].helpFlag = !helpFlag
    this.FileGroupList = listData  
   },
   setBtns_1(index_1){
    var listData = this.cheildData 
    var helpFlag = this.cheildData[index_1].helpFlag // 先用一个变量接收一个原来的状态值
     listData.forEach((item) => {  //循环已经把所有的状态值清空了
        item.helpFlag = false
    })
    listData[index_1].helpFlag = !helpFlag
    this.cheildData = listData  
   },
   // 创建子分类
   childFile(){
      console.log('234');
   },
   handleCommand(command){
      if(command == '创建子分类'){
         this.childCreateGroup()
      }else if(command == '修改分类'){
         this.dialogVisible = true
         this.filename = this.flieList.name
      }else{
         // 删除
         this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
         let params = new URLSearchParams();
         params.append('id', this.groupid)
         params.append('is_delete', '1')
         this.$axios.post(amendGroup, params).then(res => {
               this.$message({
               type: 'success',
               message: '删除成功!'
            });
            if(this.newName == '二级分类'){
         let params = new URLSearchParams();
        params.append('f_id',  this.secondgroupid);//创建人id
      //   子分组查询
      this.$axios.get(getFilegroupview,{
         params}).then(res =>{
         this.cheildData = res.data
        })
         }else if(this.newName == '三级分类'){
               this.getChildfileData3()
         }else if(this.newName == ''){
            this.getfileData()
              this.imglibrary()
          }
            // this.getfileData()
            // this.imglibrary()
            })
         }).catch(() => {
            this.$message({
               type: 'info',
               message: '已取消删除'
            });          
         });
      }
   },
   // 创建子分组
   childCreateGroup(){
      let params = new URLSearchParams();
         params.append('f_id', this.groupid)
         this.$axios.post(CreateGroup,params).then(res =>{
         console.log(res);
         if(res.status == 200){
            this.$message({
              message: '创建成功',
              type: 'success',
              duration: 1000,
              showClose: true,
            });
            if(this.newName == '二级分类'){
               this.getChildfileData3()
            }else{
               this.getChildfileData()
            }
           
         }
        })
      },
   // 子分组查询
   getChildfileData(){
      let params = new URLSearchParams();
      if(!!this.groupid){
         params.append('f_id', this.groupid);//创建人id
      //   子分组查询
      this.$axios.get(getFilegroupview,{
         params}).then(res =>{
         this.cheildData = res.data
        })
      }
      },
      // 三级子组件查询
   getChildfileData3(){
      let params = new URLSearchParams();
      params.append('f_id', this.groupid);//创建人id
      //   子分组查询
      this.$axios.get(getFilegroupview,{
         params}).then(res =>{
         this.cheildData3 = res.data
        })
      },
      // 分类修改弹窗
   // 
   handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
   },

      getinputDATA(val){
          this.filename = val
    },
   //  修改名称
   amendFile(){
      let params = new URLSearchParams();
         params.append('id', this.groupid)
         params.append('name',this.filename)
         params.append('is_delete', '0')
         this.$axios.post(amendGroup, params).then(res => {
            console.log(res);
            this.$message({
              message: '修改成功',
              type: 'success',
              duration: 1000,
              showClose: true,
            });
         })
         if(this.newName == '二级分类'){
         let params = new URLSearchParams();
        params.append('f_id',  this.secondgroupid);//创建人id
      //   子分组查询
      this.$axios.get(getFilegroupview,{
         params}).then(res =>{
            console.log(res)
         this.cheildData = res.data
        })
            }else if(this.newName == '三级分类'){
               this.getChildfileData3()
            }else if(this.newName == ''){
               this.getfileData()
            }
         this.dialogVisible = false
   //          listData.forEach((item) => {  //循环已经把所有的状态值清空了
   //           item.edit1 = false
   //       })
   //       listData.forEach((item) => {  //循环已经把所有的状态值清空了
   //      item.helpFlag = false
   //  })
   //       this.FileGroupList = listData  
   },
      // 编辑
      edit(item,index){
          var listData = this.FileGroupList 
          var edit1 = this.FileGroupList[index].edit1 // 先用一个变量接收一个原来的状态值
         if(this.confirmBtn == '编辑'){
         this.filename = item.name
          this.confirmBtn = '确定'
          this.cancelBtn = '取消'
          this.el_icon_edit = 'el-icon-circle-check'
          this.el_icon_delete = 'el-icon-circle-close'
          this.edit_state = '#409eff'
          this.delete_state = '#409eff '
         listData.forEach((item) => {  //循环已经把所有的状态值清空了
             item.edit1 = false
         })
           listData[index].edit1 = !edit1
           this.FileGroupList = listData  
           
         }else{
         let params = new URLSearchParams();
         params.append('id', this.groupid)
         params.append('name',this.filename)
         params.append('is_delete', '0')
         this.$axios.post(amendGroup, params).then(res => {
            if(res.data.status == 200){
               this.$message({
              message: '修改成功',
              type: 'success',
              duration: 1000,
              showClose: true,
            });
         }
         this.getfileData()
            
         })
            listData.forEach((item) => {  //循环已经把所有的状态值清空了
             item.edit1 = false
         })
         listData.forEach((item) => {  //循环已经把所有的状态值清空了
        item.helpFlag = false
    })
         this.FileGroupList = listData  
         // this.edit1 = true
         // this.setBtn2 = false
          this.confirmBtn = '编辑'
          this.cancelBtn = '删除'
          this.el_icon_edit = 'el-icon-edit'
          this.el_icon_delete = 'el-icon-delete'
          this.edit_state = '#409eff'
          this.delete_state = '#cf1010 '
         }
      },
      //删除
      del(item,index){
          var listData = this.FileGroupList 
          var edit1 = this.FileGroupList[index].edit1 // 先用一个变量接收一个原来的状态值
         if(this.cancelBtn == '删除'){
            this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
         let params = new URLSearchParams();
         params.append('id', this.groupid)
         params.append('is_delete', '1')
         this.$axios.post(amendGroup, params).then(res => {
            if(res.data == 'ok'){
               this.$message({
               type: 'success',
               message: '删除成功!'
            });
            }
          this.getfileData()
              this.imglibrary()
            })
            
         }).catch(() => {
            this.$message({
               type: 'info',
               message: '已取消删除'
            });          
         });
            } else{
            this.confirmBtn = '编辑'
            this.cancelBtn = '删除'
            listData.forEach((item) => {  //循环已经把所有的状态值清空了
               item.edit1 = false
            })
            listData.forEach((item) => {  //循环已经把所有的状态值清空了
         item.helpFlag = false
         })
         this.FileGroupList = listData  
         }
      },
           //上传本地图片
    uploadAction(file){
      let fd = new FormData();
      fd.append('file', file.file); //传文件
      fd.append('groupid', this.groupid)
      fd.append('p_type', '产品图片')
      this.$axios.post(uploadPictures, fd).then(res => {
        if(res.status == 200){
         this.$message({
              message: '上传成功',
              type: 'success',
              duration: 1000,
              showClose: true,
            });
        }
        if(this.allName == '全部'){
         this.imglibrary()
        }else{
         this.setBtnClicks()
        }
        
      })
    },
    handleinformationSuccess(res, file) {
      },
      // 删除图片
      delImg(){
            this.$confirm('是否删除该图片, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(() => {
         let params = new URLSearchParams();
         params.append('ImgId', this.pitchimg.join())
         this.$axios.post(allPictures,params).then(res => {
            if(res.status == 200){
               this.$message({
            type: 'success',
            message: '删除成功!'
          });
            }
            this.checkedImg = false
         if(this.allName == '全部'){
            this.imglibrary()
         }else{
            this.setBtnClicks()     
        }
              
        });
         }).catch(() => {
            this.$message({
               type: 'info',
               message: '已取消删除'
            });          
         });
      },
      // 多选
      isCheck(val){
         console.log(this.checkedImg);
         // this.isChecks = val
         this.srcList.forEach(item =>{
            if(val){
               this.checkedCities.push(item.imgUrl)
               this.pitchimg.push(item.id)
            }else{
               this.checkedCities = []
               this.pitchimg = []
            }
      //   this.checkedCities = val ? item.id : [];
         })
         // this.checkedCities = val ? this.srcList : [];
         this.isIndeterminate = false;
         // console.log(this.srcList);
      }
     },
   };
 </script>
 <style scoped>
 .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width:274px;
    height: 268px;
    line-height: 268px;
    text-align: center;
  }
  .avatar {
    width:274px;
    height: 268px;
    display: block;
  }
   /* 保存按钮 */
   .save{
      margin-left: 20px;
   }
   .box{
      display: flex;
      align-items: center;
   }
/* 图片链接 */
 .ImageLinks{
   display: flex;
   align-items: center;
   margin: 0 20px;
 }
 /* 选择商品 */
 .boxGoods{
   display: flex;
   align-items: center;
 }
 .inquire{
   margin-left: 20px;
 }
.el-input {
    width: 300px;
  }
  /* 图片设置 */
  .bottom {
   display: flex;
   align-items: center;
   justify-content: space-between;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
  }

  /* .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }

  .clearfix:after {
      clear: both
  } */
  /* 图片库 */
  .boxUpload{
  width: 60%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  /* justify-content: space-between; */
}
.boxUploads{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  /* justify-content: space-between; */
}
.demo-image__preview{
    position: relative;
    margin-right: 10px;
    /* margin-bottom: 10px; */
  }
 .checksty{
    position: absolute;
    top: 0;
    right: 0;
  }
  .imgName{
   width: 100%;
   position: absolute;
   bottom: 0;
   right: 0;
   background: rgba(0, 0, 0, .5);
   text-align: center;
   height: 30px;
   line-height: 30px;
   color: #fff;
   font-size: 12px;
   overflow: hidden;
  }
  .inptbox{
    display: flex;
    align-items: center;
   }
   .inptbox .inpt{
    width:100%;
   }
   .btn{
    display: flex;
    justify-content: space-between;
   }
   .el-col-4 {
    margin-bottom: 20px;
   }
   .bxofrom{
      display:flex;
      flex-wrap: wrap;
      align-items: center;
   }
   .elfrom{
      width: 320px;
      padding-bottom: 10px;
      margin-right: 50px;
      margin-bottom: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      background-color: #ffffff;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      border-radius: 4px;
   }
   .txtbtn{
      width: 320px;
      margin-top: 10px;
      display: flex;
      justify-content: space-around;
   }
 .inpimg{
      width: 90px;
      /* height: 20px; */
   }
  .head{
   display: flex;
   justify-content: space-between;
   align-items: center;
  }
  .line{
   border: 1px solid #d9d9d9;
  }
  /deep/ .el-input__suffix{
   display: none;
  }
  /deep/ .el-input--suffix .el-input__inner{
   height: 30px;
   border: none;
 }
 .set_foot{
   /* padding: 0px 0px 0px 5px; */
   /* margin-left: 5px; */
   cursor: pointer;
   background: #fff;
 }
 /deep/ .el-submenu [class^=el-icon-]{
   font-size: 16px;
   margin: 0;
 }
 /deep/ .el-submenu .el-menu-item{
   padding: 0px;
 }
 /* 子文件夹样式 */
 .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  .demonstration {
    display: block;
    color: #8492a6;
    font-size: 14px;
    margin-bottom: 20px;
  }
 .el-menu-vertical-demo{
   /* background: #d9d9d9; */
 }
 .el-menu-item-group__title{
   padding: 0 !important;
  }
  .menuItem{
   color:#303133;
  }
 .left_seach{
   height: 33px;
   border: 1px solid #d9d9d9;
 }
  .search{
  width: 55px;
  border: none;
  }
  .upload{
   display: flex;
  }
  .content{
   width: 62vw;
   display: flex;
   height: 360px;
   margin-top:20px;
   border-top: 1px solid #d9dadd;
   padding: 0;
   overflow: hidden;
  }
  .leftMenu{
   width: 230px;
   border-right: 1px solid #d9dadd;
   /* overflow: hidden; */
  }
  .increases{
   width: 230px;
   height: 100%;
   overflow-y: scroll;
   /* background:#d9dadd; */
  }
  .increase{
   padding: 10px;
   border-bottom: 1px solid #d9d9d9;
   cursor: pointer;
  }
  .ico{
   position: relative;
   left: 0px;
   top: 2px;
   color:#3296fa;
   font-size: 20px;
  }

  .masterPic{
   padding: 20px;
   width: calc(59vw - 230px);
   height: 360px;
   overflow-y: scroll;
  }
  .footers{
   display: flex;
   justify-content: space-between;
   align-items: end;
   margin-top: 40px;
  }
  .dialog-footer{
   display: flex;
   justify-content: center;
  }
  /deep/ .el-submenu .el-menu{
   background: #d9d9d9 !important;
  }
  /deep/ .el-menu-item-group__title{
   display: none !important;
  }
  .el-submenu{
   background: #d9d9d9 !important;
  }
 .el-menu-item:hover{  
  background: #d9d9d9 !important;   
}  
 .el-menu-item.is-active {  
   background: #d9e4f2 !important;   
}
/* 背景色 */
/deep/ .el-menu-item{
   /* padding-left: 25px !important; */
   background: #fff;
 }
  
  /* .el-input__suffix{
   height: 0px !important;
   right: none !important;
  } */

 </style>
 <style>
 .el-col-offset-1:nth-child(6){
   margin-left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/photoGallery.vue